import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  handelsbankenListTitle: {
    defaultMessage:
      'This service is not available for your account. Please follow the steps below to enable payments.',
    id: 'handelsbankenListTitle',
  },
  handelsbankenListStepOne: {
    defaultMessage: 'Log in to www.handelsbanken.se',
    id: 'handelsbankenListStepOne',
  },
  handelsbankenListStepTwo: {
    defaultMessage: 'Go to “Mobilt och BankID”, then select “Mobilapp och telefon”',
    id: 'handelsbankenListStepTwo',
  },
  handelsbankenListStepThree: {
    defaultMessage: 'Select “Personlig kod” and tick the box that says "Teckna Avtal" ',
    id: 'handelsbankenListStepThree',
  },
  handelsbankenListStepFour: {
    defaultMessage: 'Sign with BankID or card reader',
    id: 'handelsbankenListStepFour',
  },
  handelsbankenOverrideTitle: {
    defaultMessage: 'To make this payment, you need to verify your BankID.',
    id: 'handelsbankenOverrideTitle',
  },
  handelsbankenOverrideText: {
    defaultMessage:
      'Please contact Handelsbanken or open the Handelsbanken app to verify your BankID.',
    id: 'handelsbankenOverrideText',
  },
  swedbankOverrideTitle: {
    defaultMessage: 'Are you sure you have an account with the selected bank?',
    id: 'swedbankOverrideTitle',
  },
  swedbankOverrideText: {
    defaultMessage: 'If yes, please enable internet payments by contacting your bank.',
    id: 'swedbankOverrideText',
  },
  allProviderOverrideOneTitle: {
    defaultMessage: 'BankID is currently unavailable',
    id: 'allProviderOverrideOneTitle',
  },
  allProviderOverrideOneText: {
    defaultMessage: 'Please try again later or contact your bank.',
    id: 'allProviderOverrideOneText',
  },
  allProviderOverrideTwoTitle: {
    defaultMessage: 'Identification with BankID failed',
    id: 'allProviderOverrideTwoTitle',
  },
  allProviderOverrideTwoText: {
    defaultMessage: 'Please try again.',
    id: 'allProviderOverrideTwoText',
  },
  allProviderOverrideThreeTitle: {
    defaultMessage: 'You can only log in with BankID on one device at the same time',
    id: 'allProviderOverrideThreeTitle',
  },
  allProviderOverrideThreeText: {
    defaultMessage: 'Please close BankID on all other devices and try again.',
    id: 'allProviderOverrideThreeText',
  },
});
